import {
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
  faUser, // ✅ Ajouter cette icône
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap-grid.css";
import "bootstrap/dist/css/bootstrap-reboot.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Link, Links } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // ✅ Ajouter cette import
import Logo from "../assets/logo.png";
import "./../styles/header.css";
import Nav from "./nav";
import { Menu } from "lucide-react";
// import ProfilUtilisateurModal from "../pages/profilUtilisateur";
// import { useState } from "react";

export default function Header({ onMenuClick }) {
  const { client, isAuthenticated } = useAuth(); // ✅ Utiliser le contexte
  //const [showProfil, setShowProfil] = useState(false);

  return (
    <>
      <header
        className="shadow-sm border-bottom position-sticky top-0"
        style={{ zIndex: 1030, backgroundColor: "#303033", height: "14vh" }}
      >
        <Nav />
        <nav className="container-fluid px-3 px-md-5">
          <div className="d-flex align-items-center justify-content-between py-2">
            {/* === MENU HAMBURGER (mobile) === */}
            <button
              onClick={onMenuClick}
              className="d-lg-none btn btn-link p-2 text-dark"
              aria-label="Toggle menu"
            >
              <Menu size={28} />
            </button>

            {/* === LOGO === */}
            <Link
              to="/"
              className="navbar-brand d-flex align-items-center me-3"
            >
              <img
                src={Logo}
                alt="logo transfo africa"
                className="logoTransfo"
                style={{ height: "40px" }}
              />
            </Link>

            {/* Bouton hamburger visible uniquement sur mobile */}
            <div className="d-lg-none d-flex align-items-center">
              {/* Icône de profil - visible seulement si connecté */}
              {isAuthenticated && (
                <Link
                  to={"/profil"}
                  className="me-3 text-white text-decoration-none d-flex align-items-center cursor-pointer"
                >
                  {client?.image ? (
                    <img
                      src={`https://boutiqu.transfoafricainc.com/${client.image}`}
                      alt="Profil"
                      className="rounded-circle me-2"
                      style={{
                        width: "30px",
                        height: "30px",
                        objectFit: "cover",
                        border: "2px solid white",
                      }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faUser}
                      className="me-2 icon"
                      style={{ fontSize: "20px" }}
                    />
                  )}
                </Link>
              )}
              {/* Boutons auth - visibles seulement si non connecté */}
              {!isAuthenticated && (
                <div className="d-flex">
                  <Link
                    to="/inscription"
                    className="btn btn-outline-primary me-2"
                  >
                    Inscription
                  </Link>
                  <Link to="/connexion" className="btn btn-primary">
                    Connexion
                  </Link>
                </div>
              )}
            </div>

            {/* Formulaire + icônes desktop */}
            <div className="d-none d-md-flex align-items-center justify-content-between flex-grow-1 principalContainer">
              {/* Barre de recherche */}
              <form className="w-50 me-4">
                <div className="input-group">
                  <input
                    type="search"
                    className="form-control input-light"
                    placeholder="   recherche..."
                    aria-label="Recherche"
                  />
                  <button className="btn btn-outline-primary" type="submit">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </button>
                </div>
              </form>

              {/* ✅ SECTION MODIFIÉE - Ajout de l'icône profil */}
              <div className="d-flex align-items-center">
                {/* Icône de profil - visible seulement si connecté */}
                {isAuthenticated && (
                  <Link
                    to={"/profil"}
                    className="me-3 text-white text-decoration-none d-flex align-items-center cursor-pointer"
                  >
                    {client?.image ? (
                      <img
                        src={`https://boutiqu.transfoafricainc.com/${client.image}`}
                        alt="Profil"
                        className="rounded-circle me-2"
                        style={{
                          width: "35px",
                          height: "35px",
                          objectFit: "cover",
                          border: "2px solid white",
                        }}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faUser}
                        className="me-2 icon"
                        style={{ fontSize: "20px" }}
                      />
                    )}
                    <span>Mon profil</span>
                  </Link>
                )}
                {/* Boutons auth - visibles seulement si non connecté */}
                {!isAuthenticated && (
                  <div className="d-flex">
                    <Link
                      to="/inscription"
                      className="btn btn-outline-primary me-2"
                    >
                      Inscription
                    </Link>
                    <Link to="/connexion" className="btn btn-primary">
                      Connexion
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="mobileMenu"
          aria-labelledby="mobileMenuLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="mobileMenuLabel">
              Menu
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body d-flex flex-column">
            <form className="d-flex mb-3">
              <input
                className="form-control me-2 input-light"
                type="search"
                placeholder="Recherche..."
              />
              <button className="btn btn-outline-primary" type="submit">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </button>
            </form>

            <Link to="/panier" className="mb-2 text-decoration-none">
              <FontAwesomeIcon icon={faCartShopping} className="me-2" />
              Mon panier
            </Link>

            <Link to="/favoris" className="mb-2 text-decoration-none">
              <FontAwesomeIcon icon={faHeart} className="me-2" />
              Favoris
            </Link>

            {/* ✅ SECTION MOBILE MODIFIÉE */}
            {/* Lien profil - visible seulement si connecté */}
            {isAuthenticated && (
              <Link
                to={"/profil"}
                className="mb-2 text-decoration-none d-flex align-items-center"
                //onClick={() => setShowProfil(true)}
              >
                {client?.image ? (
                  <img
                    src={`https://boutiqu.transfoafricainc.com/${client.image}`}
                    alt="Profil"
                    className="rounded-circle me-2"
                    style={{
                      width: "25px",
                      height: "25px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                )}
                Mon profil
              </Link>
            )}

            {/* Boutons auth - visibles seulement si non connecté */}
            {!isAuthenticated && (
              <>
                <Link
                  to="/inscription"
                  className="btn btn-outline-primary mb-2"
                >
                  Inscription
                </Link>
                <Link to="/connexion" className="btn btn-primary">
                  Connexion
                </Link>
              </>
            )}
          </div>
        </div>
      </header>
      {/* <ProfilUtilisateurModal
        show={showProfil}
        onClose={() => setShowProfil(false)}
      /> */}
    </>
  );
}
